import { render, staticRenderFns } from "./analisis.vue?vue&type=template&id=5c28d4e4&"
import script from "./analisis.vue?vue&type=script&lang=js&"
export * from "./analisis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports